const pausedByObserver = new WeakMap();

const observer = new IntersectionObserver(
  /**
   * If video is playing when it leaves the viewport, pause it.
   * If video then re-enters the viewport, play it.
   */
  (entries) => {
    entries.forEach((entry) => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Video is entering the viewport - play it if it was paused
        // by the observer.
        if (pausedByObserver.get(video)) {
          video.play();
          pausedByObserver.set(video, false);
        }
      } else {
        // Video is leaving the viewport - pause it and track that it was
        // paused by the observer.
        if (
          !video.paused &&
          document.pictureInPictureElement !== video &&
          !video.hasAttribute("autoplay")
        ) {
          video.pause();
          pausedByObserver.set(video, true);
        }
      }
    });
  },
  { threshold: 0.5 },
);

const videoPause = "video-is-paused";
const videoPlay = "video-is-playing";
const videoPoster = "video-has-poster";
const videoPlayed = "video-played";

export function play({ el, buttonEl, videoEl, hasAudio = true }) {
  el.classList.add("background-video--video-started");
  buttonEl.classList.remove(videoPause);
  buttonEl.classList.add(videoPlay);

  // first time played
  if (!videoEl.classList.contains(videoPlayed)) {
    buttonEl.classList.remove(videoPoster);
    videoEl.classList.add(videoPlayed);

    if (hasAudio) {
      videoEl.setAttribute("controls", "true");
    }
  }

  if (videoEl.paused) {
    videoEl.play();
  }

  return true;
}

export function pause({ buttonEl, videoEl }) {
  buttonEl.classList.remove(videoPlay);
  buttonEl.classList.add(videoPause);
  videoEl.pause();
}

export default (selector = ".js-background-video") => {
  return document.querySelectorAll(selector).forEach((el) => {
    const buttonEl = el.querySelector(".js-background-video-button");
    const videoEl = el.querySelector(".js-background-video-media");

    const autoplay = videoEl.hasAttribute("autoplay");
    const hasAudio = videoEl.dataset.hasAudio === "True"; // C# bool is True not true
    const poster = videoEl.hasAttribute("poster");

    observer.observe(videoEl);

    if (autoplay && hasAudio) {
      // let the native controls do their thing.
      videoEl.setAttribute("controls", "true");
      return;
    }

    if (autoplay) {
      play({ el, buttonEl, videoEl, hasAudio });
    } else {
      buttonEl.classList.add(videoPause);
      buttonEl.classList.remove(videoPlay);
    }

    if (poster && !autoplay) {
      buttonEl.classList.add(videoPoster);
    } else {
      buttonEl.classList.remove(videoPoster);
    }

    bindEvents();

    function bindEvents() {
      const handleClick = (e) => {
        e.preventDefault();
        if (videoEl.paused) {
          play({ el, buttonEl, videoEl, hasAudio });

          if (hasAudio) {
            videoEl.removeEventListener("click", handleClick);
          }
        } else {
          pause({ buttonEl, videoEl });
        }
      };

      videoEl.addEventListener("click", handleClick);

      buttonEl.addEventListener("click", (e) => {
        if (videoEl.paused) {
          play({ el, buttonEl, videoEl, hasAudio });
        } else {
          pause({ buttonEl, videoEl });
        }
      });
    }
  });
};
